import { assertNever } from '@deltasierra/type-utilities';
import { PublishTarget } from '../enums';
import { PublishableService } from '../types';

// eslint-disable-next-line complexity
export function getPublishableServiceForPublishTarget(publishTarget: PublishTarget): PublishableService {
    switch (publishTarget) {
        case PublishTarget.campaignMonitor:
            return 'campaignMonitor';
        case PublishTarget.clubready:
            return 'clubReady';
        case PublishTarget.glofox:
            return 'glofox';
        case PublishTarget.kite:
            return 'kite';
        case PublishTarget.marianaTek:
            return 'marianaTek';
        case PublishTarget.mindbody:
            return 'mindbody';
        case PublishTarget.zenoti:
            return 'zenoti';
        case PublishTarget.facebookPostLegacy:
        case PublishTarget.facebookPost:
            return 'facebook';
        case PublishTarget.googleMyBusinessPostLegacy:
        case PublishTarget.googleMyBusinessPost:
            return 'googleMyBusiness';
        case PublishTarget.instagramPostLegacy:
        case PublishTarget.instagramReelLegacy:
        case PublishTarget.instagramStoryLegacy:
        case PublishTarget.instagramPost:
        case PublishTarget.instagramReel:
        case PublishTarget.instagramStory:
            return 'instagram';
        case PublishTarget.linkedinPostLegacy:
        case PublishTarget.linkedinPost:
            return 'linkedIn';
        case PublishTarget.localEmail:
        case PublishTarget.localMedia:
        case PublishTarget.localPrint:
            return 'local';
        default:
            return assertNever(publishTarget);
    }
}
